import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";

export type ChangeTextProps = Omit<BaseTextProps, "inherit">;

export const ChangeText = ({ children, ...textProps }: ChangeTextProps) => {
    return (
        <BaseText {...textProps} inherit>
            {children}
        </BaseText>
    );
};
